/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */
import * as References from './MarketplaceStorefrontPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc#getSearchFilterConfig
 */
export const GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_marketplace_storefront_service_rpc_MarketplaceStorefrontPublicRpc_getSearchFilterConfig';
export const GET_SEARCH_FILTER_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEARCH_FILTER_CONFIG_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSearchFilterConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});